var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.wrapper,
    ( _obj = {}, _obj[_vm.$style.wrapper_availableProfile] = this.availableViewProfile, _obj ) ]},_vm._l((_vm.listeners),function(listener){return _c('router-link',{key:listener.id,class:_vm.$style.listenerCard,attrs:{"to":("listeners/" + (listener.id))},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var navigate = ref.navigate;
return [_c('user-card',{attrs:{"user":listener},nativeOn:{"click":function($event){return navigate($event)}}})]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }